import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Moon.svg",
  "use": "Moon.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Moon.svg\"><path d=\"M24.9994,18.004A20.9977,20.9977,0,0,0,45.99,39.0093a20.5954,20.5954,0,0,0,5.6866-.92,1.8161,1.8161,0,0,1,2.1329,2.5321A22.9472,22.9472,0,1,1,23.4151,10.1787a1.8181,1.8181,0,0,1,2.5354,2.1344A20.6148,20.6148,0,0,0,24.9994,18.004Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol